import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import _ from 'lodash';
import firebase from 'firebase';
import QuickInfo from '../../QuickInfo';
import AttractionsList from '../../AttractionsList';
import './styles.css';

const Details = (props) => {
    // const [topCities, setTopCities] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [signedOut, setSignedOut] = useState(false);

    const { city } = useParams();
    const history = useHistory();

    useEffect(async () => {
        const topCities = await fetchOurTopCities();
        const allCities = _.flatMap(topCities, ({ cities }) =>  _.map(cities));

        const foundCity = _.find(allCities, { name: city });
        setSelectedCity(foundCity);
    }, []);

    const fetchOurTopCities = () => {
        return fetch('../data/recommended_cities.json')
            .then(res => res.json())
            .catch(function(error) {
                console.log("Hit an error!");
                console.log(error);
            });
    };

    const onClickSignOut = () => {
        firebase.auth().signOut();
        setSignedOut(true);
    }

    const onClickFavorites = (city) => {
        alert(city.name)
        firebase.database.ref().collection('FavoriteLocations').doc(props.user.uid).set(props.user.uid)
    }

    if (signedOut) {
        history.go();
    }

    if (selectedCity) {
        const { name, pic, attractions } = selectedCity
        // console.log('currcity' + props.currCity);
        // console.log('seelectedcity' + selectedCity);
        return (
            <div>
                <div className="card">
                    <img src={pic} alt="Cover image" className="card-img" />
                    <div className="card-text">
                        <h2 className="card-title">{`Touristy's ${name} Guide`}</h2>
                        <div>
                            <QuickInfo {...selectedCity} />
                            <AttractionsList attractions={attractions} />
                        </div>
                    </div>
                </div>
                <div>
                    <button className="buttonDetail1"><a href="/">Go Back</a></button>
                    <button className="button"  onClick={()=>{ onClickFavorites(selectedCity) }}>Add to Favourites</button>
                </div>
                <center>
                    <p>© Elizabeth Lin, Ginsu Eddy, Arjun Aggarwal</p>
                    <button className="button" onClick={() => onClickSignOut()}>Sign Out</button>
                </center>
            </div>
        );
    } else {
        return (
            <div>
                <center>
                    <p>© Elizabeth Lin, Ginsu Eddy, Arjun Aggarwal</p>
                </center>
            </div>
        );
    }

};

export default Details;